import { IdentifierRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * identifierOnSaveListData - Function that saves on database an list of driver identifiers  
 * /identifiers/list  
 * method POST  
 * @async-function
 */
const identifierOnSaveListData = async (token: string, list: Array<IdentifierRequestType>) => {
    const response = await api.post(
        `/identifiers/list`, {
           list
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default identifierOnSaveListData;